// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.non-existent-account-button {
  margin-bottom: 1rem;
  text-transform: capitalize;
}

.login-action.login label.login-field {
  margin-bottom: var(--ce-body-default);
  display: block;
}


.turnstile-container
{
    margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Login.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;;AAGA;;IAEI,mBAAmB;AACvB","sourcesContent":[".non-existent-account-button {\n  margin-bottom: 1rem;\n  text-transform: capitalize;\n}\n\n.login-action.login label.login-field {\n  margin-bottom: var(--ce-body-default);\n  display: block;\n}\n\n\n.turnstile-container\n{\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
